import { useCreativeEffects, useLiveRendering, useMessaging } from './hooks';

const LiveRenderingEffects = () => {
  useMessaging();
  useCreativeEffects();

  return null;
};

export function LiveRendering() {
  const { enabled } = useLiveRendering();
  if (enabled) {
    return <LiveRenderingEffects />;
  }
  return null;
}
